module.exports = __webpack_public_path__ + "static/media/remote.e89d4672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/remec/remote.png
// module id = 123
// module chunks = 0